import { ComponentProps } from 'react'

import {
  createMemoryRouter,
  RouterProvider,
  UNSAFE_LocationContext as LocationContext,
  useNavigate,
} from 'react-router-dom'

import { journeyRoutes } from './routes'

export const createJourneyRouter = (...[routes, opts]: Parameters<typeof createMemoryRouter>) => {
  return createMemoryRouter([...routes, ...journeyRoutes], opts)
}

type JourneyRouter = ReturnType<typeof createJourneyRouter>

export const JourneyRouter = ({ router }: { router: JourneyRouter }) => {
  // grab parent browser router navigate function
  const navigate = (useNavigate() ?? router.navigate) as JourneyRouter['navigate']
  /**
   * This is a hack to allow the memory router to work inside a browser router
   */
  const FORCE_OVERRIDE_LOCATION_TO_ALLOW_MEMORY_ROUTER = null as unknown as ComponentProps<
    typeof LocationContext.Provider
  >['value']

  return (
    <LocationContext.Provider value={FORCE_OVERRIDE_LOCATION_TO_ALLOW_MEMORY_ROUTER}>
      <RouterProvider router={{ ...router, navigate }} />
    </LocationContext.Provider>
  )
}
